module.exports = __webpack_public_path__ + "img/logo.126c50ad.svg";